module.exports = __webpack_public_path__ + "static/img/zc-succeed.5fc93db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zc-succeed.jpg
// module id = VlYe
// module chunks = 5